import React from "react";
import { useLocation } from "react-router-dom";
import PublicApp from "./PublicApp";
import AgentApp from "./AgentApp";
import { PORTAL_BASE } from "./portal/portalRoutes";

const PUBLIC_PATHS = ["/login", "/public", PORTAL_BASE];

const isPublicPath = (pathname: string) =>
  PUBLIC_PATHS.some((path) => pathname.startsWith(path));

/**
 * App — top-level dispatcher only.
 * Routes public paths to PublicApp, everything else to AgentApp.
 * No providers, no hooks, no layout logic here.
 */
const App: React.FC = () => {
  const { pathname } = useLocation();
  return isPublicPath(pathname) ? <PublicApp /> : <AgentApp />;
};

export default App;
